import { axiosInstance } from './axiosConfig.ts';

export interface RamaProfesional {
    id: number;
    codigo: string;
    nombre: string;
    icono: string;
    color: string;
    color_dark: string;
    subramas: string[];
    orden: number;
    activo: boolean;
    created_at?: string;
    updated_at?: string;
}

export const fetchRamasProfesionales = async (): Promise<RamaProfesional[]> => {
    const res = await axiosInstance.get('ramas-profesionales/');
    if (Array.isArray(res.data)) {
        return res.data;
    }
    if (res.data && Array.isArray(res.data.results)) {
        return res.data.results;
    }
    return [];
};

export const createRamaProfesional = async (data: Partial<RamaProfesional>): Promise<RamaProfesional> => {
    const res = await axiosInstance.post('ramas-profesionales/', data);
    return res.data;
};

export const updateRamaProfesional = async (id: number, data: Partial<RamaProfesional>): Promise<RamaProfesional> => {
    const res = await axiosInstance.put(`ramas-profesionales/${id}/`, data);
    return res.data;
};

export const deleteRamaProfesional = async (id: number): Promise<void> => {
    await axiosInstance.delete(`ramas-profesionales/${id}/`);
};

export const agregarSubrama = async (id: number, subrama: string): Promise<RamaProfesional> => {
    const res = await axiosInstance.post(`ramas-profesionales/${id}/agregar_subrama/`, { subrama });
    return res.data;
};

export const eliminarSubrama = async (id: number, subrama: string): Promise<RamaProfesional> => {
    const res = await axiosInstance.post(`ramas-profesionales/${id}/eliminar_subrama/`, { subrama });
    return res.data;
};
